module.exports = __webpack_public_path__ + "static/media/wechat_open_web.98714af6.png";